<template>
  <transition name="modal">
    <div v-if="show" class="modal-wrapper">
      <div class="modal-container">
        <button class="icon-wrapper" @click.prevent="closePrompt">
          <Icon class="icon" name="xmark" art="light" />
        </button>
        <p class="text" v-html="texts.prompt_text" />
        <button class="link" @click.prevent="startSurvey">
          <strong>{{ texts.prompt_action_accept }}</strong>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Icon from '../common/Icon'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Prompt',
  components: {
    Icon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['texts']),
  },
  methods: {
    ...mapActions(['startSurvey', 'closePrompt']),
  },
}
</script>

<style scoped lang="postcss">
.modal-wrapper {
  position: fixed;
  z-index: 1;
  top: 20%;
}

.modal-container {
  position: relative;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  width: 280px;
  padding: 20px;
}

button {
  background: white;
  color: #5bac26;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: #4d8e23;
  }
}

.text {
  font-size: 15px;
  margin: 0 15px 0 0;
}

.link {
  font-size: 15px;
  margin-top: 20px;
}

.icon-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 8px;
}

.icon {
  font-size: 16px;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s linear, transform 0.3s ease-in-out;
}

@media only screen and (max-width: 768px) {
  .modal-enter,
  .modal-leave-to {
    opacity: 0;
    transform: translateY(50%);
  }

  .modal-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}

@media only screen and (min-width: 769px) {
  .modal-enter,
  .modal-leave-to {
    opacity: 0;
    transform: translateX(100%);
  }

  .modal-wrapper {
    right: 20px;
  }
}
</style>
